import React from 'react';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

const Footer =()=>{
    return(

    <MDBRow className="mt-5 footer">
        <MDBCol className="text-center">
            &copy; 2023 WNS Sentry
        </MDBCol>
    </MDBRow>
)

}
export default Footer;